import PropTypes from 'prop-types';
import React from "react";

import SettingsModal from "./SettingsModal.jsx";
import ShareModal from "./ShareModal.jsx";
import ExportModal from "./ExportModal.jsx";

import autobind from "autobind-decorator";

import compose from "lib/compose";
import Mappable from "lib/Mappable";

import DataHandler from "../common/DataHandler";
import DefaultKeySelector from "../common/DefaultKeySelector";
import AutoGranularity from "../common/AutoGranularity";
import DataFilter from "../common/DataFilter";
import DataCombiner from "../common/DataCombiner";
import TopFilter from "../common/TopFilter";
import HoverData from "../common/HoverData";

import {ChartSelector} from "../charts/index";

let datapipeline = [
    DataFilter,
    AutoGranularity,
    DataCombiner,
    TopFilter
];

const Chart = compose(
    ...datapipeline,
    HoverData
)(ChartSelector);

export const DataMappedChart = Chart;

export const DataMapper = compose(...datapipeline);

export class ChartWrapper extends React.Component {
    static propTypes = {
        actions: PropTypes.objectOf(PropTypes.func),
        chart: PropTypes.object,
        colors: PropTypes.object,
        dataset: PropTypes.object,
        embedded: PropTypes.bool,
        id: PropTypes.number,
        index: PropTypes.number,
        isExposed: PropTypes.bool,
        isSelected: PropTypes.bool,
        timezone: PropTypes.number,
        children: PropTypes.node
    };

    static displayName = 'ChartWrapper';

    @autobind
    getRef(name) {
        let ref = this[name+ "Ref"];
        while (typeof ref.getWrappedInstance === "function") {
            ref = ref.getWrappedInstance();
        }

        return ref;
    }

    @autobind
    showShare() {
        this.getRef("share").open();
    }

    @autobind
    showSettings() {
        this.getRef("settings").open();
    }

    @autobind
    showExport() {
        this.getRef("export").open();
    }

    @autobind
    screenshot() {
        this.getRef("chart").takeScreenshot();
    }

    @autobind
    editChart(config) {
        const {index, actions} = this.props;
        return actions.editChart(index, config);
    }

    @autobind
    selectChart() {
        const {index, actions, isExposed} = this.props;

        if (isExposed) {
            actions.expose(false);
        }

        actions.selectChart(index);
    }

    @autobind
    remove(event) {
        event.stopPropagation();
        const {actions, index} = this.props;
        actions.deleteChart(index);
    }

    @autobind
    _handleKeyPress(e) {
        const tagRex = /^(button|input|textarea|select)$/i;
        if (e.target.tagName && e.target.tagName.match(tagRex)) {
            return;
        }

        if (e.shiftKey && (e.keyCode !== 37 && e.keyCode !== 39) ||
            e.metaKey || e.ctrlKey || e.altKey) {
            return;
        }

        if (!this.props.isSelected || this.props.isExposed) {
            return;
        }

        var key = String.fromCharCode(e.keyCode).toLowerCase();

        if (key === "e") {
            this.showExport();
        } else if (key === "c") {
            this.showSettings();
        } else if (key === "p") {
            this.screenshot();
        }else if (key === "s") {
            this.showShare();
        }
    }


    componentDidMount() {
        if (!this.props.embedded) {
            window.addEventListener("keydown", this._handleKeyPress);
        }

        if (!this.props.chart.dataset) {
            this.showSettings();
        }
    }

    componentWillUnmount() {
        window.removeEventListener("keydown", this._handleKeyPress);
    }

    shouldComponentUpdate(nextProps) {
        for (let prop of Object.keys(nextProps)) {
            if (this.props[prop] !== nextProps[prop]) {
                return true;
            }
        }

        return false;
    }

    render() {
        const {dataset, isSelected, isExposed, chart, colors, timezone} = this.props;
        let selected = isSelected ? " selected" : "";

        let chartProps = new Mappable({colors, timezone, isSelected: isSelected && !isExposed, ...chart, dataset})
            .filter((value, key) => key != "id")
            .toObject();

        return (
            <div onClick={this.selectChart} className={"chart-wrapper" + selected}>
                <div className="flex max">
                    {this.props.children}
                    <div className="grow relative">
                        <div className="icons">
                            <ShareModal ref={el => this.shareRef = el} current={chart}>
                                <i className="icon-link" title="Share [s]"/>
                            </ShareModal>

                            <ExportModal ref={el => this.exportRef = el} dataMapper={DataMapper} {...chartProps} title="Export">
                                <i className="icon-export" title="Export [e]"/>
                            </ExportModal>

                            <i className="icon-camera" onClick={this.screenshot} title="Take screenshot [p]"/>

                            <SettingsModal
                                ref={el => this.settingsRef = el}
                                settings={chart}
                                dataset={dataset}
                                onChange={this.editChart}
                            >
                                <i className="icon-cog" title="Configuration [c]"/>
                            </SettingsModal>
                        </div>
                        <div className="remove-chart" onClick={this.remove}></div>
                        <Chart ref={el => this.chartRef = el} key={chart.type} {...chartProps} />
                    </div>
                </div>
            </div>
        );
    }
}

export default compose(
    DataHandler,
    DefaultKeySelector
)(ChartWrapper);


// WEBPACK FOOTER //
// ./src/kpi/components/ChartWrapper.jsx